export const minInputLength = 12;
export const maxInputLength = 128;
export const maxTextareaLength = 500;
